// Small validation helpers shared across forms.
// Feb 2026 (iter-184) — introduced to validate phone + email inputs
// on the Company create/edit forms.

// RFC 5322-lite email — good enough for UI, real deliverability is enforced
// server-side (or by the actual mail provider).
export const isValidEmail = (v) => {
  if (v == null) return false;
  const s = String(v).trim();
  if (!s) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(s);
};

// International-friendly phone: allows an optional leading '+', digits,
// spaces, hyphens, dots, and parens; must contain at least 7 digits.
export const isValidPhone = (v) => {
  if (v == null) return false;
  const s = String(v).trim();
  if (!s) return false;
  if (!/^[+()\-.\s\d]+$/.test(s)) return false;
  const digits = s.replace(/\D/g, '');
  return digits.length >= 7 && digits.length <= 15;
};
